import { patientActions, noteActions, cdvActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'
import { supervisors } from '_services/_schemas';

const initialState = {
    supervisors:[]
};

export const reducer = createReducer(initialState, {

    [patientActions.loadSuccess]: (state, action) => {
        var patients = {};

        Object.values(action.payload.entities.patients).forEach(x => {
            patients[x.id] = {
                id: x.id,
                addendumVisible: false,
                addendumDoc: undefined,
                scribeVisible: false,
                scribeDoc: undefined,
                clinicalDocsVisible: true,
                fotoDocsVisible: true
            };
        });
        state = { ...state, ...patients };

        return state;
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        return { ...state, ...action.payload.ui.cdvOptions };
    },
    [patientActions.closeSuccess]: (state, action) => {
        delete state[action.payload];
    },
    [patientActions.loadSupervisiorsSuccess]: (state, action) => {
        state.supervisors = action.payload.supervisors;
    },
    [noteActions.showAddendum]: (state, action) => {
        state[action.payload.ptno].addendumVisible = true;
        state[action.payload.ptno].addendumDoc = action.payload.noteId;
    },
    [noteActions.hideAddendum]: (state, action) => {
        state[action.payload.ptno].addendumVisible = false;
        state[action.payload.ptno].addendumDoc = undefined;
    },
    [noteActions.showScribe]: (state, action) => {
        state[action.payload.ptno].scribeVisible = true;
        state[action.payload.ptno].scribeDoc = action.payload.noteId;
    },
    [noteActions.hideScribe]: (state, action) => {
        state[action.payload.ptno].scribeVisible = false;
        state[action.payload.ptno].scribeDoc = undefined;
    },
    [noteActions.saveAddendumSuccess]: (state, action) => {
        state[action.payload].addendumVisible = false;
        state[action.payload].addendumDoc = undefined;
    },
    [cdvActions.toggleClinicalDocsVisibility]: (state, action) => {
        state[action.payload].clinicalDocsVisible = !state[action.payload].clinicalDocsVisible
    },
    [cdvActions.toggleFotoDocsVisibility]: (state, action) => {
        state[action.payload].fotoDocsVisible = !state[action.payload].fotoDocsVisible
    }


})


